/* eslint-disable no-shadow */
/* eslint-disable no-use-before-define */
import { useSelector } from 'react-redux'
import React, { useEffect, useState } from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import { CircularProgress } from '@mui/material'
import { InfoOutlined } from '@mui/icons-material'
import { isEqual } from 'lodash'

import { get } from 'services/api'
import ResumeTable from 'components/ResumeTable'
import ExpandedInfo from 'components/ExpandedInfo'
import { Modal, Pagination } from 'components'
import SearchBar from 'components/SearchBar'
import { setApplicationQueryParam, setSearchFiltersQueryParams, buildApplicationSearchParams, getFilterValuesFromQueryParams } from 'utils/functions'
import { Scopes } from 'utils/authUtils'
import ForbiddenAccessAlert from '../../components/ForbiddenAccessAlert'
import styles from './styles'

const HomeContent = () => {
  const classes = styles()
  const token = useSelector((state) => state.auth.access_token)
  const history = useHistory()
  const location = useLocation()
  const applicationUuid = new URLSearchParams(location.search).get('application_uuid')
  const initialPage = Math.max(0, (parseInt(new URLSearchParams(location.search).get('page'), 10) || 1) - 1)

  const [modal, setModal] = useState(Boolean(applicationUuid))
  const [loading, setLoading] = useState(false)
  const [applications, setApplications] = useState(null)
  const [clickedPerson, setClickedPerson] = useState(
    applicationUuid ? { uuid: applicationUuid } : null,
  )
  const [page, setPage] = useState(initialPage)
  const [size, setSize] = useState(10)
  const [pagesNumber, setPagesNumber] = useState(1)
  const [searchParams, setSearchParams] = useState(() =>
    buildApplicationSearchParams(getFilterValuesFromQueryParams(location.search)),
  )

  useEffect(() => {
    getData()

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page, size, searchParams])

  useEffect(() => {
    setSearchFiltersQueryParams(history, { page: page > 0 ? page + 1 : undefined })

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page])

  const getData = async () => {
    setLoading(true)

    const res = await get({
      url: `/applications`,
      token,
      params: { ...searchParams, page: page + 1, size: size },
    })

    setApplications(res?.items)
    setPagesNumber(res?.total)
    setLoading(false)
  }

  const handleOpenModal = (info) => {
    setClickedPerson(info)
    setModal(true)
    setApplicationQueryParam(history, info.uuid)
  }

  const handleCloseModal = () => {
    setClickedPerson(null)
    setModal(false)
    setApplicationQueryParam(history)
  }

  const handlePageChange = (event, page) => {
    setPage(page)
  }

  const handleChangeRowsPerPage = (event) => {
    setSize(event.target.value)
    setPage(0)
  }

  const handleChangeSearchTerm = (value) => {
    if (!isEqual(searchParams, value)) {
      setPage(0)
      setSearchParams(value)
    }
  }

  const reloadData = () => {
    getData()
  }

  return (
    <div className={classes.root}>
      <div className={classes.content}>
        <div className={classes.topBar}>
          <SearchBar searchParams={searchParams} setSearchParams={handleChangeSearchTerm} />
        </div>

        {loading ? (
          <div className={classes.loading}>
            <CircularProgress size={64} color="primary" />
            <span className={classes.loadingText}>Buscando aplicações...</span>
          </div>
        ) : (
          <React.Fragment>
            {false && (
              <div className={classes.containers}>
                <div className={classes.dataContainer}>
                  Estatísticas desse mês
                </div>

                <div className={classes.dataContainer}>
                  Estatísticas de todos os tempos
                </div>
              </div>
            )}

            <div className={classes.tableContainer}>
              {applications ? (
                <ResumeTable
                  data={applications}
                  handleOpenModal={handleOpenModal}
                  reloadData={reloadData}
                />
              ) : (
                <div className={classes.noData}>
                  <span>
                    <InfoOutlined fontSize="inherit" />
                  </span>
                  <span>Nenhum registro encontrado</span>
                </div>
              )}
            </div>

            <Pagination
              count={pagesNumber}
              component="div"
              page={page}
              rowsPerPage={size}
              rowsPerPageOptions={[10, 15, 20, 25, 30]}
              onPageChange={handlePageChange}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />

            {clickedPerson && (
              <Modal
                open={modal}
                onClose={handleCloseModal}
                title="Informações detalhadas da aplicação"
              >
                <ExpandedInfo
                  handleClose={handleCloseModal}
                  application_id={clickedPerson.uuid}
                />
              </Modal>
            )}
          </React.Fragment>
        )}
      </div>
    </div>
  )
}

const Home = () => (
  <ForbiddenAccessAlert
    requriedScopes={[Scopes.APPLICATION_LIST]}
    screenName="Lista de Aplicações"
  >
    <HomeContent />
  </ForbiddenAccessAlert>
)

export default Home
